import TipText from '@/components/TipText'
import { useTranslation } from '@sailor/i18n-web'
import React from 'react'
import { IRulePackage } from '../utils/types'
import { staffStatusOptions } from '@/common/utils/consts'
import { BudgetFeeConfigTypeEnum, BudgetFeeTypeEnum } from '../pages/detail/utils'
import { isEqualString } from '@/common/utils'
import useRuleConfig from '@/common/recoil/atom/ruleConfigAtom'
import { replaceMoneySymbol } from '@/common/utils/i18nFuncs'

const IssuanceInfoRender = ({ record }: {record: IRulePackage}) => {
  const { t } = useTranslation()
  const { budgetFeeConfig } = useRuleConfig() || {}
  const sycleOptionMaps = [
    ...(budgetFeeConfig?.periodConfig || []),
    { periodType: 0, i18nTextValue: t('e_pc_one_time_issuance', '一次下发') },
  ]
  const currentSycleOption = sycleOptionMaps.find(item => isEqualString(item.periodType, record.budgetFeeRule?.periodType))

  const renderBudgetInfo = () => {
    const isExcel  = isEqualString(record.budgetFeeRule?.amountFrom, BudgetFeeConfigTypeEnum.EXCEL)
    const currency = budgetFeeConfig?.currency || '--'
    const displayMoneyText = record.budgetFeeRule?.amount?.displayText ||  `${record.budgetFeeRule?.budgetAmountDisplayText}${replaceMoneySymbol(currency)}`
    return isExcel
      ? `${t('e_pc_custom_amount', '自定义')}/${t('e_pc_one_time_issuance', '一次性下发')}`
      : <span > <TipText text={`${replaceMoneySymbol(displayMoneyText)}/${currentSycleOption?.i18nTextValue || '--'}`} /></span>
  }

  return (
    isEqualString(record.budgetFeeType, BudgetFeeTypeEnum.BUDGET)
      ? renderBudgetInfo()
      : (
        <div>
          <div style={{ display: 'flex' }}>
            <div style={{ whiteSpace: 'nowrap' }}>{t('e_pc_related_balance_batch', '关联余额批次')}:&nbsp;</div>
            <TipText text={record.balanceBatchInfo?.batchList?.map(item => item?.batchName).join(',') || '--'} />
          </div>
          <div>
            <span>{t('e_pc_apply_status', '适用状态')}:&nbsp;</span>
            {
              !record.staffStatusRule?.checkStaffStatus
                ?  t('e_pc_no_status_limit', '不区分状态')
                : record.staffStatusRule?.availableStaffStatusCodeList?.map(code => staffStatusOptions[`${code}`])
                  .map(item => t(item?.i18nKey) || item?.label)
                  .join(',') || '--'
            }
          </div>
        </div>
      )

  )
}
export default IssuanceInfoRender